export const MAP_TYPES_PRICES = {
  Count: 'COUNT',
  None: 'NONE',
  Percent: 'PERCENT',
  PerHour: 'PER_HOUR',
  EmailSignature: 'EMAIL_SIGNATURE',
  Single: 'SINGLE',
  Sum: 'SUM',
  Asap: 'ASAP'
};
